export default __webpack_public_path__ + "1cdcf50ce905e85b25d7477942d77400.svg";